<div class="below-navbar materials" [class.has-items]="locationDayreportKeys?.length > 0">
    <div class="content container">
        <p class="small text-truncate w-100 mb-0">
            {{ planning?.location }}
        </p>

        <div class="d-flex justify-content-between align-items-center mt-2">
            <h4 class="mb-0">Productie</h4>

            <app-day-report-nav-buttons />
        </div>

        @if (declarationLocked) {
            <div class="alert alert-warning">
                De verrekening van dit dagrapport is al definitief. De productie kan niet meer worden aangepast.
            </div>
        } @else if (readOnly && !canStart) {
            <div class="alert alert-warning">Dit dagrapport is niet wijzigbaar in deze status.</div>
        }
    </div>

    <div class="list">
        <div class="content">
            @if (locationDayreportKeys?.length > 0) {
                @for (locationKey of locationDayreportKeys; track locationKey) {
                    @let locationGroup = locationDayreports[locationKey];

                    <div
                        class="header"
                        [class.empty]="!locationGroup.items.length"
                        (click)="locationGroup.open = !locationGroup.open">
                        <div class="container-xl">
                            <div class="name-wrapper">
                                <div class="name">{{ locationGroup.label }}</div>
                            </div>
                            <div class="prefix">
                                <button
                                    class="icon-button"
                                    [class.active]="locationGroup.open"
                                    mat-icon-button
                                    color="primary">
                                    <mat-icon fontSet="fas" fontIcon="fa-chevron-down"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    @for (adr of locationGroup.items; track adr.id) {
                        @if (adr.article_crm_id) {
                            @if (locationGroup.open) {
                                <div class="article">
                                    <div class="container">
                                        <div class="content">
                                            <div class="d-flex justify-content-between align-items-center material">
                                                Bestekpost:
                                                {{ adr.article_crm?.description ?? adr.article_crm?.crm_article_id }}
                                            </div>

                                            <div class="d-flex justify-content-between align-items-center mt-2 aantal">
                                                <div class="d-flex align-items-center">
                                                    <span class="font-weight-bold">
                                                        {{ adr.amount }}
                                                        {{ adr.article_crm?.unit }}
                                                    </span>
                                                    <br />
                                                </div>

                                                @if (Functionalities.DayreportsMutate | hasFunctionality: user) {
                                                    <button
                                                        [disabled]="readOnly"
                                                        (click)="delete(adr)"
                                                        mat-icon-button
                                                        aria-label="Verwijderen"
                                                        color="primary">
                                                        <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        } @else {
                            @let article = adr.article;
                            @let material = materials | byId: adr.material_id;
                            @let width = material | materialProperty: 'width';

                            @if (locationGroup.open) {
                                <div class="article">
                                    <div class="container">
                                        <div class="content">
                                            <div class="d-flex justify-content-between align-items-center material">
                                                {{ article?.group }} - {{ article?.name }}
                                            </div>

                                            <div class="result d-flex justify-content-between align-items-center">
                                                <span class="name text-left">
                                                    <strong>{{ material | materialProperty: 'name' }}</strong>
                                                    <small class="text-muted">
                                                        {{ material | materialProperty: 'usage' }}
                                                    </small>

                                                    @if (width) {
                                                        &nbsp;<small class="text-muted">({{ width }} cm)</small>
                                                    }
                                                    <br />

                                                    @for (
                                                        rawMaterialId of adr.raw_materials_ids;
                                                        track rawMaterialId;
                                                        let isLast = $last
                                                    ) {
                                                        @let rawMaterial = rawMaterials | byId: rawMaterialId;
                                                        @let materialRawMaterial =
                                                            getMaterialRawMaterial(material, rawMaterialId);
                                                        @let type = materialTypes | byId: rawMaterial?.material_type_id;
                                                        @let name = rawMaterial?.name;
                                                        @let consumption =
                                                            materialRawMaterial?.pivot?.consumption ??
                                                            materialRawMaterial?.consumption;

                                                        @if (!type?.hidden) {
                                                            <div class="row w-100">
                                                                <small class="text-muted col">
                                                                    {{ name }}
                                                                    @if (type?.name !== name) {
                                                                        {{ type?.name }}
                                                                    }
                                                                </small>
                                                                <span class="text-end col">
                                                                    {{ consumption | number: '0.0-2' }}
                                                                    {{ rawMaterial?.consumption_type?.name }}
                                                                    *
                                                                    {{ adr.amount }}
                                                                    {{ article?.article_unit_type?.name }}
                                                                    *
                                                                    {{ article?.factor | number: '0.0-5' }}
                                                                    =
                                                                    {{
                                                                        consumption * article?.factor * adr.amount
                                                                            | number: '0.2-2'
                                                                    }}
                                                                    kg
                                                                </span>
                                                            </div>
                                                        }
                                                    }
                                                </span>

                                                <span class="color text-right d-flex align-items-center">
                                                    {{ material | materialProperty: 'colorName' }}&nbsp;

                                                    @let colorName = material | materialProperty: 'colorName';
                                                    @let color = material | materialProperty: 'color';

                                                    @if (colorName) {
                                                        <span
                                                            class="color-circle-small me-2"
                                                            [class.transparent]="colorName === 'transparant'"
                                                            [style.background]="color"></span>
                                                    } @else {
                                                        <span class="d-inline-block size-24"></span>
                                                    }

                                                    <strong>{{ material | materialProperty: 'colorRal' }}</strong>
                                                </span>
                                            </div>

                                            <div class="d-flex justify-content-between align-items-center mt-2 aantal">
                                                <div class="d-flex align-items-center">
                                                    <span class="font-weight-bold">
                                                        {{ adr.amount }}
                                                        {{ article.article_unit_type?.name }}
                                                    </span>
                                                    <br />
                                                </div>

                                                @if (Functionalities.DayreportsMutate | hasFunctionality: user) {
                                                    <button
                                                        [disabled]="readOnly"
                                                        (click)="delete(adr)"
                                                        mat-icon-button
                                                        aria-label="Verwijderen"
                                                        color="primary">
                                                        <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        }
                    }
                }
            } @else {
                <div class="article">
                    <div class="container">
                        <div class="content">
                            @if (canStart) {
                                Start opdracht om productie toe te voegen.
                            } @else {
                                Geen productie toegevoegd.
                            }
                        </div>
                    </div>
                </div>
            }

            @if (productionTotals.length > 0) {
                <div class="production-total">
                    <div class="container-xl">
                        <div class="heading">
                            <h4 class="mb-0">Totaal productie</h4>
                        </div>

                        <div class="breakdown">
                            @for (total of productionTotals; track total.rawMaterialId) {
                                <div class="d-flex justify-content-end">
                                    <span>{{ total.name }}</span>
                                    <span class="font-weight-bold ms-2">
                                        {{ total.totalKg | number: '0.0-2' }} kg
                                    </span>
                                </div>
                            }
                        </div>

                        <div class="grand-total text-end">
                            Totaal gewicht: {{ productionTotalKg | number: '1.0-0' }} kg
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<app-day-report-buttons
    [navigationDisabled]="saving"
    [showActionButton]="Functionalities.DayreportsMutate | hasFunctionality: user"
    [actionButtonDisabled]="readOnly && !canStart"
    (actionButtonClick)="startOrAdd()"
    activePage="productie"
    [actionButtonText]="readOnly && canStart ? 'Opdracht starten' : 'Toevoegen'"
    actionButtonIcon="far fa-plus" />
